import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;

import { observable, runInAction, makeObservable, computed } from "mobx";
import { persist } from "mobx-persist";
import * as yup from "yup";
import { isPhoneNumberValid, normalizePhoneNumber } from "@dp/common";
var phoneRegExp = /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s-]?[\0-9]{3}[\s-]?[0-9]{4}$/;

var _SCHEMA = yup.object({
  vehicleType: yup.string().when(["isPickupEligible", "isCurbsidePickupSelected"], {
    is: function is(isPickupEligible, isCurbsidePickupSelected) {
      return isPickupEligible === true && isCurbsidePickupSelected === true;
    },
    then: yup.string().required("Please select vehicle type"),
    otherwise: yup.string()
  }),
  isPickingOrder: yup["boolean"](),
  pickupPerson: yup.string().when("isPickingOrder", {
    is: true,
    then: yup.string().matches(/^[a-zA-Z ]+$/, "Only alphabets are allowed for this field").max(32, "Max. characters allowed are 32").required("This field is mandatory")
  }),
  vehicleColor: yup.string().when(["isPickupEligible", "isCurbsidePickupSelected"], {
    is: function is(isPickupEligible, isCurbsidePickupSelected) {
      return isPickupEligible === true && isCurbsidePickupSelected === true;
    },
    then: yup.string().required("Please select vehicle color"),
    otherwise: yup.string()
  }),
  curbSideMobile: yup.string().when(["isCurbsidePickupSelected"], {
    is: function is(isCurbsidePickupSelected) {
      return isCurbsidePickupSelected === true;
    },
    then: yup.string().nullable(true).required("Please enter phone number").matches(phoneRegExp, "Phone number is not valid"),
    otherwise: yup.string().nullable()
  }),
  pickupPersonMobile: yup.string().when(["_pickupPersonMobile"], {
    is: function is(pickupPersonMobile) {
      return !!pickupPersonMobile;
    },
    then: yup.string().matches(phoneRegExp, "Phone number is not valid"),
    otherwise: yup.string().nullable()
  })
});

var PickupInfoModel = (_class = /*#__PURE__*/function () {
  function PickupInfoModel(platformUtil) {
    _classCallCheck(this, PickupInfoModel);

    _initializerDefineProperty(this, "_appAttributes", _descriptor, this);

    _initializerDefineProperty(this, "_isPickingOrder", _descriptor2, this);

    _initializerDefineProperty(this, "_pickupPerson", _descriptor3, this);

    _initializerDefineProperty(this, "_vehicleType", _descriptor4, this);

    _initializerDefineProperty(this, "_vehicleColor", _descriptor5, this);

    _initializerDefineProperty(this, "_pickupPersonMobile", _descriptor6, this);

    _initializerDefineProperty(this, "_deliveryDriverInfo", _descriptor7, this);

    _initializerDefineProperty(this, "_curbSideMobile", _descriptor8, this);

    _initializerDefineProperty(this, "_carSidePickupAvailable", _descriptor9, this);

    _initializerDefineProperty(this, "_inRestaurantPickupAvailable", _descriptor10, this);

    _initializerDefineProperty(this, "_openColor", _descriptor11, this);

    _initializerDefineProperty(this, "_isPickupEligible", _descriptor12, this);

    _initializerDefineProperty(this, "_componentRef", _descriptor13, this);

    _initializerDefineProperty(this, "_isCurbsidePickupSelected", _descriptor14, this);

    _initializerDefineProperty(this, "_isCurbsideNotificationEnabled", _descriptor15, this);

    _defineProperty(this, "platformUtil", void 0);

    this.platformUtil = platformUtil;
    this._isPickingOrder = false;
    this._openColor = false;
    this._isCurbsidePickupSelected = false;
    makeObservable(this);
  }

  _createClass(PickupInfoModel, [{
    key: "setAppAttributes",
    value: function setAppAttributes(_appAttributes) {
      var _this = this;

      runInAction(function () {
        _this._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "handleInvalidModel",
    value: function handleInvalidModel(appMessages) {
      var _this2 = this;

      var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      appMessages.showError("Missing Details.", "Please enter all highlighted fields.", null, {
        okBtnText: "OK",
        okBtnOnClick: function okBtnOnClick() {
          _this2.platformUtil.scrollToElement(_this2.componentRef, isMobile ? 30 : 0);
        }
      });
      this.platformUtil.dispatchEvent("AnalyticsEvent", "DisplayModal", {
        modalIntent: "Error modal for missing pickup information",
        modalContent: "Error modal for missing pickup information",
        modalName: "PickupInfo-Error-Modal"
      });
    }
  }, {
    key: "isPickingOrder",
    get: function get() {
      return this._isPickingOrder;
    },
    set: function set(val) {
      var _this3 = this;

      runInAction(function () {
        _this3._isPickingOrder = val;
        if (val === false) _this3.pickupPerson = "";
      });
    }
  }, {
    key: "pickupPerson",
    get: function get() {
      return this._pickupPerson;
    },
    set: function set(val) {
      var _this4 = this;

      runInAction(function () {
        _this4._pickupPerson = val;
      });
    }
  }, {
    key: "vehicleType",
    get: function get() {
      return this._vehicleType;
    },
    set: function set(val) {
      var _this5 = this;

      runInAction(function () {
        _this5._vehicleType = val;
      });
    }
  }, {
    key: "vehicleColor",
    get: function get() {
      return this._vehicleColor;
    },
    set: function set(val) {
      var _this6 = this;

      runInAction(function () {
        _this6._vehicleColor = val;
      });
    }
  }, {
    key: "pickupPersonMobile",
    get: function get() {
      return this._pickupPersonMobile;
    },
    set: function set(value) {
      var _this7 = this;

      var newNumber = normalizePhoneNumber(value, this._pickupPersonMobile);
      runInAction(function () {
        _this7._pickupPersonMobile = newNumber;
      });
    }
  }, {
    key: "isPickupPersonPhoneValid",
    get: function get() {
      if (!this.pickupPersonMobile) {
        return true;
      } else {
        return isPhoneNumberValid(this.pickupPersonMobile);
      }
    }
  }, {
    key: "curbSideMobile",
    get: function get() {
      return this._curbSideMobile;
    },
    set: function set(value) {
      var _this8 = this;

      var newNumber = normalizePhoneNumber(value, this._curbSideMobile);
      runInAction(function () {
        _this8._curbSideMobile = newNumber;
      });
    }
  }, {
    key: "isPickupEligible",
    get: function get() {
      return this._isPickupEligible;
    },
    set: function set(val) {
      var _this9 = this;

      runInAction(function () {
        _this9._isPickupEligible = val;
      });
    }
  }, {
    key: "deliveryDriverInfo",
    get: function get() {
      return this._deliveryDriverInfo;
    },
    set: function set(val) {
      var _this10 = this;

      runInAction(function () {
        _this10._deliveryDriverInfo = val;
      });
    }
  }, {
    key: "carSidePickupAvailable",
    get: function get() {
      return this._carSidePickupAvailable;
    },
    set: function set(carSidePickupAvailable) {
      var _this11 = this;

      runInAction(function () {
        _this11._carSidePickupAvailable = carSidePickupAvailable;
      });
    }
  }, {
    key: "inRestaurantPickupAvailable",
    get: function get() {
      return this._inRestaurantPickupAvailable;
    },
    set: function set(inRestaurantPickupAvailable) {
      var _this12 = this;

      runInAction(function () {
        _this12._inRestaurantPickupAvailable = inRestaurantPickupAvailable;
      });
    }
  }, {
    key: "openColor",
    get: function get() {
      return this._openColor;
    },
    set: function set(val) {
      var _this13 = this;

      runInAction(function () {
        _this13._openColor = val;
      });
    }
  }, {
    key: "errors",
    get: function get() {
      var errObj = {};

      try {
        _SCHEMA.validateSync(this, {
          abortEarly: false
        });
      } catch (e) {
        var error = e;
        error.inner.forEach(function (err) {
          errObj[err.params.path] = err.message;
        });
      }

      return errObj;
    }
  }, {
    key: "isCurbSidePhoneValid",
    get: function get() {
      return isPhoneNumberValid(this.curbSideMobile);
    }
  }, {
    key: "isVehicleTypeValid",
    get: function get() {
      return !!this.vehicleType;
    }
  }, {
    key: "ispickupPersonValid",
    get: function get() {
      return !!this.pickupPerson;
    }
  }, {
    key: "isValid",
    get: function get() {
      return _SCHEMA.isValidSync(this);
    }
  }, {
    key: "isCarsideValid",
    get: function get() {
      return this.isVehicleTypeValid && this.isVehicleColorValid;
    }
  }, {
    key: "isVehicleColorValid",
    get: function get() {
      return this.vehicleType && !!this.vehicleColor;
    }
  }, {
    key: "driver_instruction_max_length",
    get: function get() {
      var _this$_appAttributes, _this$_appAttributes$;

      return parseInt(this === null || this === void 0 ? void 0 : (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$.checkout_driver_instruction_maxlength) || 50;
    }
  }, {
    key: "componentRef",
    get: function get() {
      return this._componentRef;
    },
    set: function set(_componentRef) {
      var _this14 = this;

      runInAction(function () {
        _this14._componentRef = _componentRef;
      });
    }
  }, {
    key: "isCurbsidePickupSelected",
    get: function get() {
      return this._isCurbsidePickupSelected;
    },
    set: function set(val) {
      var _this15 = this;

      runInAction(function () {
        _this15._isCurbsidePickupSelected = val;
      });
    }
  }, {
    key: "isCurbsideNotificationEnabled",
    get: function get() {
      return this._isCurbsideNotificationEnabled;
    },
    set: function set(isCurbsideNotificationEnabled) {
      var _this16 = this;

      runInAction(function () {
        _this16._isCurbsideNotificationEnabled = isCurbsideNotificationEnabled;
      });
    }
  }]);

  return PickupInfoModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_isPickingOrder", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_pickupPerson", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_vehicleType", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_vehicleColor", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_pickupPersonMobile", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_deliveryDriverInfo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_curbSideMobile", [persist, observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_carSidePickupAvailable", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_inRestaurantPickupAvailable", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_openColor", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_isPickupEligible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_componentRef", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_isCurbsidePickupSelected", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_isCurbsideNotificationEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isPickingOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPickingOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pickupPerson", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pickupPerson"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vehicleColor", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "vehicleColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pickupPersonMobile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "pickupPersonMobile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPickupPersonPhoneValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPickupPersonPhoneValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "curbSideMobile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "curbSideMobile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPickupEligible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPickupEligible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryDriverInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryDriverInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "carSidePickupAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "carSidePickupAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "inRestaurantPickupAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "inRestaurantPickupAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openColor", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "openColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "errors", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "errors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCurbSidePhoneValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCurbSidePhoneValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isVehicleTypeValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isVehicleTypeValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "ispickupPersonValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "ispickupPersonValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCarsideValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCarsideValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isVehicleColorValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isVehicleColorValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "driver_instruction_max_length", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "driver_instruction_max_length"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "componentRef", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "componentRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCurbsidePickupSelected", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCurbsidePickupSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCurbsideNotificationEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCurbsideNotificationEnabled"), _class.prototype)), _class);
export { PickupInfoModel as default };